var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReports(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 96.59998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "48- \u06AF\u0632\u0627\u0631\u0634\u0627\u062A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M118.16,61.05a8.99046,8.99046,0,0,0-6.49-2.6h-6.55l-8.81-.34-.19-32.5c0-1.96-1.91-3.56-4.25-3.56H82.03V14.53c0-1.96-1.91-3.55-4.24-3.55H15.17c-2.57,0-4.66,1.75-4.66,3.89v5.71H6.05C2.72,20.58,0,22.85,0,25.64V101.65c0,3.28,3.18,5.93,7.1,5.93h93.03c3.25,0,6.11-1.92,6.79-4.57L119.8,66.88a5.3839,5.3839,0,0,0,.2-1.48A6.25469,6.25469,0,0,0,118.16,61.05ZM24.59,25.96V67.67c0,.31-10.94,30.38-11.25,30.38L13.27,87.2V14.87a1.771,1.771,0,0,1,1.9-1.59H77.79a1.37828,1.37828,0,0,1,1.48,1.25v7.52H29.25C26.69,22.05,24.59,23.8,24.59,25.96ZM84.34,58.25V32H77.88V58.37l-3.68.06V47.71H67.75V58.45H64.06V32H57.61V58.45H53.92V42.11H47.47V58.45H43.78V32H37.33l.1,26.21H33.94c-4.9.7-4.9,3.49-6.3,5.59l-.28-37.84a1.754,1.754,0,0,1,1.89-1.59H91.87a1.38063,1.38063,0,0,1,1.49,1.24V40.56l.17,17.53Z",
    transform: "translate(0 -10.97998)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/Reports.e4aa6c2f33424f83d6907d6bccc14713.svg";
export { ForwardRef as ReactComponent };